import type { IconData } from '@stacksjs/iconify-core'

export const hotSpring: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M10 27.292C5.704 28.94 3 31.335 3 34c0 4.97 9.402 9 21 9s21-4.03 21-9c0-1.437-.786-2.795-2.183-4\"/><path d=\"M24 3c-4 4.694-4 12.306 0 17s4 12.306 0 17M13 7c-4 3.59-4 9.41 0 13s4 9.41 0 13M35 7c-4 3.59-4 9.41 0 13s4 9.41 0 13\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default hotSpring
